import { postRequest, postRequestNoLoading } from 'utils/http';
import { BACKEND_API } from 'global/environment';
import { cui } from 'components';

const baseURL = BACKEND_API;

const transformAppList = function (response) {
  const linkGGplay = 'https://play.google.com/store/apps/details?id=';
  cui.each(response.result, item => {
    item.google_store = `${linkGGplay}${item.android_package}`;
  });
  return response;
};

const transformProvinces = function (response) {
  const newList = response.result.map(item => {
    return {
      value: item.ID || item.PROVINCE_ID,
      text: item.PROVINCE_NAME,
      provinceCode: item.CCBS_CODE,
      id: item.PROVINCE_ID
    }
  });
  response.transformList = newList;
  return response;
};

const transformDistrict = function (response) {
  const newList = response.result.map(item => {
    return {
      value: item.DISTRICT_ID,
      text: item.DISTRICT_NAME
    }
  });
  response.transformList = newList;
  return response;
};

const transformWard = function (response) {
  const newList = response.result.map(item => {
    return {
      value: item.PRECINCT_ID,
      text: item.PRECINCT_NAME
    }
  });
  response.transformList = newList;
  return response;
};

const transformStreet = function (response) {
  const newList = response.result.map(item => {
    return {
      value: item.STREET_ID,
      text: item.STREET_NAME
    }
  });
  response.transformList = newList;
  return response;
};

const transformLocation = function (response) {
  cui.each(response.result, item => {
    item.lat = parseFloat(item.LATITUDE);
    item.lng = parseFloat(item.LONGITUDE);
  });
  return response;
};

const transformCountries = function (response) {
  const newList = response.result.map(item => {
    return {
      value: item.COUNTRY,
      text: item.COUNTRY,
    }
  });
  response.transformList = newList;
  return response;
};

const transformVendors = function (response) {
  const newList = response.result.map(item => {
    return {
      value: item.CODE,
      text: item.NAME,
    }
  });
  response.transformList = newList;
  return response;
};

const transformVin = function (response) {
  response.data = response.data.map(item => {
    return {
      ...item,
      value: item.name,
      text: item.name,
    }
  });
  response.result = response.result.map(item => {
    return {
      ...item,
      value: item.short_name,
      text: item.name,
    }
  });
  return response;
};

const transformPlaceList = function (response) {
  response.result = response.result.map(item => {
    return {
      ...item,
      value: item.SHORT_NAME,
      text: item.NAME,
    }
  });
  return response;
};

export const AdminService = {
  getBanner: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/media_get_banner`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getProvinces: function (successCallback, failCallback,) {
    const URL = `${baseURL}/help_get_provinces`;
    return postRequestNoLoading(URL, {}, {}, successCallback, failCallback, transformProvinces);
  },

  getProvinces1800: function (data, successCallback, failCallback,) {
    const URL = `${baseURL}/help_get_provinces_1800`;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback, transformProvinces);
  },

  getProvincesLanToa: function (data, successCallback, failCallback,) {
    const URL = `${baseURL}/help_get_provinces_lantoa`;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback, transformProvinces);
  },

  getDistricts1800: function (data, successCallback, failCallback,) {
    const URL = `${baseURL}/help_get_districts_1800`;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback, transformDistrict);
  },

  getWards1800: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/help_get_precinct_1800`;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback, transformWard);
  },

  getStreet1800: function (data, successCallback, failCallback,) {
    const URL = `${baseURL}/help_get_street_1800`;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback, transformStreet);
  },

  getKhuPhoAp: function (data, successCallback, failCallback,) {
    const URL = `${baseURL}/help_get_khu_pho_ap_1800`;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback, transformStreet);
  },

  // Nơi cấp CMND
  getVinListCity: function (data, successCallback, failCallback,) {
    const URL = `${baseURL}/vin_list_city`;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback, transformVin);
  },

  getPlaceFromId: function (data, successCallback, failCallback,) {
    const URL = `${baseURL}/myvnpt_list_gt_noicap `;
    return postRequest(URL, data, {}, successCallback, failCallback, transformPlaceList);
  },

  // Khu
  getListArea: function (data, successCallback, failCallback,) {
    const URL = `${baseURL}/help_get_area_1800 `;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback, transformStreet);
  },

  // Ấp
  getListIncubation: function (data, successCallback, failCallback,) {
    const URL = `${baseURL}/help_get_incubation_1800 `;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback, transformStreet);
  },

  getAppsHot: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/media_get_app_link_lists`;
    return postRequest(URL, data, {}, successCallback, failCallback, transformAppList);
  },

  getFrequentlyErrors: function (successCallback, failCallback) {
    const URL = `${baseURL}/custservice_get_frequently_errors_all`;
    return postRequest(URL, {}, {}, successCallback, failCallback);
  },

  getStoreHomeMobi: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/help_get_stores_by_lnglat`;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback, transformLocation);
  },

  getStoreHomeMobiByProvince: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/help_get_stores_by_province`;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback, transformLocation);
  },

  getCountries: function (successCallback, failCallback,) {
    const URL = `${baseURL}/mobile_ir_country_list`;
    return postRequestNoLoading(URL, {}, {}, successCallback, failCallback, transformCountries);
  },

  getVendorByCountry: function (data, successCallback, failCallback,) {
    const URL = `${baseURL}/mobile_get_ir_partner`;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback, transformVendors);
  },
};

